/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreManagementSyncItemResponse } from './StoreManagementSyncItemResponse';

export type StoreManagementSyncItemResponseApiRespoonse = {
    data?: StoreManagementSyncItemResponse;
    status?: StoreManagementSyncItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreManagementSyncItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

